import Theme from '@qnpm/q-theme';
import { statusBarUtil } from '@qnpm/q-design-utils';
const { font, color, layout } = Theme;
const { scenes } = color;
const { navBarColors } = scenes;
const { navbar: navBarLayout } = layout;
// 刘海屏高度
export const NOTCH_HEIGHT = statusBarUtil.getStatusBarHeight();
function getComputedStyle(needScale) {
    const fontSize = needScale
        ? font.size.scaled
        : font.size.unscaled;
    const lineHeight = needScale
        ? font.lineHeight.scaled
        : font.lineHeight.unscaled;
    const navBarSize = needScale
        ? navBarLayout.scaled
        : navBarLayout.unscaled;
    return {
        fontSize,
        lineHeight,
        navBarSize
    };
}
// 通用样式
const getBaseStyle = (adaptNotch, needScale) => {
    const { fontSize, lineHeight, navBarSize } = getComputedStyle(needScale);
    return {
        wrapper: {
            height: navBarSize.height + (adaptNotch ? NOTCH_HEIGHT : 0),
            paddingTop: adaptNotch ? NOTCH_HEIGHT : 0,
            backgroundColor: navBarColors.white,
            width: '100%'
        },
        title: {
            title: {
                fontSize: fontSize.fontSizeXL,
                lineHeight: lineHeight.lineHeightT18,
                fontWeight: font.weight.fontWeightBold,
                color: navBarColors.title
            },
            subtitle: {
                fontSize: fontSize.fontSizeS,
                lineHeight: lineHeight.lineHeightT12,
                color: navBarColors.subtitle
            }
        },
        multiTitle: {
            title: {
                fontSize: fontSize.fontSizeM,
                lineHeight: lineHeight.lineHeightT12,
                color: navBarColors.title
            },
            subtitle: {
                fontSize: fontSize.fontSizeS,
                lineHeight: lineHeight.lineHeightT12,
                color: navBarColors.subtitle
            }
        },
        arrow: {
            fontSize: fontSize.fontSizeXS,
            color: navBarColors.arrow
        }
    };
};
// 按钮&文字通用样式
const getButtonStyle = (adaptNotch, needScale) => {
    const { fontSize, lineHeight, navBarSize } = getComputedStyle(needScale);
    return {
        icon: {
            fontSize: fontSize.fontSizeX2L,
            color: navBarColors.icon
        },
        text: {
            fontSize: fontSize.fontSizeXS,
            lineHeight: lineHeight.lineHeightT10,
            color: navBarColors.iconText
        },
        pureIcon: {
            fontSize: fontSize.fontSizeX2L,
            color: navBarColors.icon
        },
        pureText: {
            fontSize: fontSize.fontSizeM,
            lineHeight: lineHeight.lineHeightT14,
            color: navBarColors.iconText
        },
        container: {
            width: navBarSize.buttonSize.width,
            height: navBarSize.buttonSize.height,
            marginTop: adaptNotch ? NOTCH_HEIGHT : 0
        },
        pureTextContainer: {
            width: 'auto',
            height: navBarSize.buttonSize.height,
            paddingHorizontal: navBarSize.buttonSize.padding,
            marginTop: adaptNotch ? NOTCH_HEIGHT : 0
        }
    };
};
// 预设配色模板
const presetModeStyle = {
    blank: {
        backgroundColor: navBarColors.white,
        color: navBarColors.title,
        subColor: navBarColors.subtitle,
        icon: navBarColors.icon
    },
    brand: {
        backgroundColor: navBarColors.primaryBackground,
        color: navBarColors.white,
        subColor: navBarColors.white,
        icon: navBarColors.white
    },
    ghost: {
        backgroundColor: 'transparent',
        color: navBarColors.title,
        subColor: navBarColors.subtitle,
        icon: navBarColors.icon
    },
    crystal: {
        backgroundColor: 'transparent',
        color: navBarColors.white,
        subColor: navBarColors.white,
        icon: navBarColors.white
    }
};
export default {
    getBaseStyle,
    getButtonStyle,
    presetModeStyle
};
